export const filterWeekSummary = (weekSummary, intervalId) => {
  const newWeekSummary = { ...weekSummary };
  Object.keys(weekSummary).map((key) => {
    newWeekSummary[key] = weekSummary[key].filter((x) => x.id !== intervalId);
  });
  return newWeekSummary;
};

export const filterEditedDays = (intervals,
  initialIntervals, intervalId, editedDays) => {
  let newEditedDays = editedDays;
  if (!editedDays) {
    newEditedDays = [];
  } else {
    newEditedDays = [...editedDays];
  }
  const interval = intervals.find((x) => x.intervalId === intervalId);
  const startDay = parseInt(interval.startDay);
  const endDay = parseInt(interval.endDay);
  if (initialIntervals.findIndex((x) => x.intervalId === intervalId) !== -1) {
    newEditedDays.push(startDay);
    newEditedDays.push(endDay);
    for (let i = startDay + 1; i < endDay; i += 1) {
      newEditedDays.push(i);
    }
  } else {
    let index = newEditedDays.findIndex((x) => x === startDay);
    newEditedDays.splice(index, 1);
    index = newEditedDays.findIndex((x) => x === endDay);
    newEditedDays.splice(index, 1);
    for (let i = startDay + 1; i < endDay; i += 1) {
      index = newEditedDays.findIndex((x) => x === i);
      newEditedDays.splice(index, 1);
    }
  }
  return newEditedDays;
};